import { gql } from '@apollo/client';

// Ad on Trafficking Page
export const AD_TRAFFICKING_COLUMN = gql`
  fragment adTraffickingColumn on AdV5 {
    __typename
    id
    name
    type
    review
    status
    startDate
    endDate
    unDeletable
    schedule {
      timezone
      deliveryInViewerTime
      dateRangeList {
        startDate
        endDate
        pacingShare
      }
      dayPartList {
        activeDayList
        firstActiveHour
        lastActiveHour
      }
    }
    frequencyCapList {
      type
      limit
      duration
      durationUnit
      enabled
    }
    createdAt
    creative {
      id
      review
      type
      metadata {
        countryCodes
        createdAt
        creativeId
        deleted
        isLegalApproved
        updatedAt
      }
    }
    updatedAt
    lineItem {
      startDate
      endDate
      id
      name
      adProduct
      inventoryBlockId
      exclusiveBlock {
        id
        name
        lineItemIdList
        blockedIndustryList {
          id
          name
        }
        targetingTermValues {
          category {
            id
            name
            displayName
          }
          dimension {
            id
            name
            displayName
          }
          value {
            id
            name
            displayName
          }
          include
        }
      }
      parentLineOmsLink {
        id
      }
      lineOmsLink {
        id
        type
      }
      campaign {
        name
        id
        adAccount {
          id
          timezone
          organizationId
        }
        campaignTagList {
          id
          type
          url
        }
        crmLink {
          id
          name
        }
        startDate
      }
      schedule {
        timezone
        dateRangeList {
          startDate
          endDate
          pacingShare
        }
        dayPartList {
          firstActiveHour
          lastActiveHour
          activeDayList
        }
        deliveryInViewerTime
      }
      displayPublisherTarget
      billableThirdParty
      isCoppaOrCaru
      country
      countries
    }
    viewabilityVendorList
    sequence
    adRotation {
      rotationName
      rotationId
      weight
    }
    adSequence {
      adId
      sequenceId
      order
      name
      updatedAt
      podPosition
      podAlignment
    }
    trackingId
    displayPublisherTarget
    hasMisalignedSchedule
    hasInvalidPublisher
    hasInvalidCountry
    countriesTarget
    adTagList {
      id
      type
      event
      url
      isVerified
      unDeletable
      autoVerified
      isIas
    }
  }
`;
